<div mat-dialog-title style="display: inline-flex; align-items: center;">
  <h2 style="margin: 0; width:99%">Custom AI Prompt</h2>
  <div style="font-size: 16px; width:1%; color: inherit; background-color: inherit; cursor: pointer;"
       (click)="close()">
    <span class="fal fa-times"></span>
  </div>
</div>
<mat-dialog-content style="overflow: hidden; height: 375px;">
  <div style="display: flex; flex-direction: row; width:100%; overflow: hidden ">
    <div class="prompt-list-column">
      <div class="header">
        <mat-form-field class="search-box">
          <mat-label>Search All Available</mat-label>
          <input matInput type="search" [formControl]="searchBox" />
        </mat-form-field>
      </div>
      <mat-list dense style="height:83%; overflow: auto;">
        <div class="grey-header" style="padding-right: 7px">
          <div class="grey-header-left">Shared</div>
          <mat-icon class="grey-header-right">share</mat-icon>
        </div>
        <mat-list style="overflow: hidden;">
          <mat-list-item *ngFor="let prompt of sharedPrompts"
                         [ngClass]="{'prompt-list-selected-item': selectedPrompt?.promptId === prompt.promptId , 'prompt-list-row-item': selectedPrompt?.promptId !== prompt.promptId }"
                         (click)="select(prompt)">
            <div class="icon-button-line">
              <div mat-line> {{prompt.title}} </div>
              <button mat-icon-button [matMenuTriggerFor]="shared_action_menu" (click)="$event.stopPropagation()" class="more-vert-button">
                <mat-icon class="grey-header-right more-vert-icon">more_vert</mat-icon>
              </button>
            </div>
            <mat-menu #shared_action_menu>
              <div [ngClass]="{'dark-theme-menu-item dark-theme': isDarkMode()}">
                <button mat-menu-item [disabled]="prompt.createdById !== currentUserId" class="more-action-button" (click)="unshareOrUnpinPrompt(prompt)">Unshare</button>
                <button mat-menu-item [disabled]="prompt.createdById !== currentUserId" class="more-action-button" (click)="pinPrompt(prompt)">Pin</button>
                <button mat-menu-item [disabled]="prompt.createdById !== currentUserId" class="more-action-button" (click)="deletePrompt(prompt)">Delete</button>
              </div>
            </mat-menu>
            <mat-divider></mat-divider>
          </mat-list-item>
        </mat-list>
        <div class="grey-header-below" style="padding-right: 7px">
          <div class="grey-header-left">Pinned</div>
          <mat-icon class="grey-header-right">push_pin</mat-icon>
        </div>
        <mat-list style="overflow: hidden;">
          <mat-list-item *ngFor="let prompt of pinnedPrompts"
                         [ngClass]="{'prompt-list-selected-item': selectedPrompt?.promptId === prompt.promptId , 'prompt-list-row-item': selectedPrompt?.promptId !== prompt.promptId }"
                         (click)="select(prompt)">
            <div class="icon-button-line">
              <div mat-line> {{prompt.title}} </div>
              <button mat-icon-button [matMenuTriggerFor]="pinned_action_menu" (click)="$event.stopPropagation()" class="more-vert-button">
                <mat-icon class="grey-header-right more-vert-icon">more_vert</mat-icon>
              </button>
            </div>
            <mat-menu #pinned_action_menu>
              <div [ngClass]="{'dark-theme-menu-item dark-theme': isDarkMode()}">
                <button mat-menu-item [disabled]="prompt.createdById !== currentUserId" class="more-action-button" (click)="sharePrompt(prompt)">Share</button>
                <button mat-menu-item [disabled]="prompt.createdById !== currentUserId" class="more-action-button" (click)="unshareOrUnpinPrompt(prompt)">Unpin</button>
                <button mat-menu-item [disabled]="prompt.createdById !== currentUserId" class="more-action-button" (click)="deletePrompt(prompt)">Delete</button>
              </div>
            </mat-menu>
            <mat-divider></mat-divider>
          </mat-list-item>
        </mat-list>
        <div class="grey-header-below" style="padding-right: 7px">
          <div class="grey-header-left">Recent</div>
          <mat-icon class="grey-header-right">history</mat-icon>
        </div>
        <mat-list style="overflow: hidden;">
          <mat-list-item *ngFor="let prompt of recentPrompts"
                         [ngClass]="{'prompt-list-selected-item': selectedPrompt?.promptId === prompt.promptId , 'prompt-list-row-item': selectedPrompt?.promptId !== prompt.promptId }"
                         (click)="select(prompt)">
            <div class="icon-button-line">
              <div mat-line> {{prompt.title}} </div>
              <button mat-icon-button [matMenuTriggerFor]="recent_action_menu" (click)="$event.stopPropagation()" class="more-vert-button">
                <mat-icon class="grey-header-right more-vert-icon">more_vert</mat-icon>
              </button>
            </div>
            <mat-menu #recent_action_menu>
              <div [ngClass]="{'dark-theme-menu-item dark-theme': isDarkMode()}">
                <button mat-menu-item [disabled]="prompt.createdById !== currentUserId" class="more-action-button" (click)="sharePrompt(prompt)">Share</button>
                <button mat-menu-item [disabled]="prompt.createdById !== currentUserId" class="more-action-button" (click)="pinPrompt(prompt)">Pin</button>
                <button mat-menu-item [disabled]="prompt.createdById !== currentUserId" class="more-action-button" (click)="deletePrompt(prompt)">Delete</button>
              </div>
            </mat-menu>
            <mat-divider></mat-divider>
          </mat-list-item>
        </mat-list>
      </mat-list>
    </div>
    <div class="column" style="margin: 0px 10px 0px 10px; height: 100%;">
      <div class="header">
        <h2>Details</h2>
      </div>
      <form [formGroup]="promptForm" class="column">
        <mat-form-field appearance="fill" style="width:100%">
          <mat-label class="title">Title</mat-label>
          <input matInput placeholder="Prompt Title" maxlength="256" formControlName="title" required>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width:100%">
          <textarea matInput
                    formControlName="fullPrompt"
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="8"
                    cdkAutosizeMaxRows="8"
                    disabled></textarea>
        </mat-form-field>
      </form>
      <div style="display:flex; float: right; justify-content:end">
        <button mat-raised-button color="primary" *ngIf="displaySave()" [disabled]="disableSave()" (click)="save()">Save</button>
      </div>
    </div>
  </div>
</mat-dialog-content>